import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const ProtectedRoute = ({ route }) => {
  const { isLoaggedIn } = useAuth();

  if (!isLoaggedIn) {
    return <Navigate to="/" />;
  }

  return route.Component? <route.Component />: null;
};

export default ProtectedRoute;
